import React, { useMemo } from 'react'
import { css } from '@codemirror/lang-css'
import CodeMirrorEditor from './CodeMirrorEditor'
import { useEditorContent } from './useEditor'
import ResizableEditorContainer from '../shared/ResizableEditorContainer'

/**
 * CssEditor: Context-aware CSS editor component
 *
 * Uses editor context instead of props for clean architecture.
 * No props needed - all data comes from EditorProvider context.
 */
const CssEditor = () => {
	const { content, updateCss, editorConfig } = useEditorContent()

	// 🎯 PERFORMANCE: Stable extensions reference with centralized config
	const extensions = useMemo(() => [css()], [])

	return (
		<ResizableEditorContainer minHeight={editorConfig.css.minHeight} theme={editorConfig.css.theme}>
			<CodeMirrorEditor value={content.css} onChange={updateCss} extensions={extensions} />
		</ResizableEditorContainer>
	)
}

export default CssEditor
